import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/lib/authContext";
import { useSessionUser } from "@/hooks/useSessionUser";

type OwnerRouteProps = {
  children: ReactNode;
};

export default function OwnerRoute({ children }: OwnerRouteProps) {
  const { isAuthenticated } = useAuth();
  const { user } = useSessionUser();
  const normalizedUserType = user?.user_type?.toLowerCase() ?? "";
  const isOwner = Boolean(user?.is_owner || normalizedUserType === "owner");

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isOwner) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
